import { render, staticRenderFns } from "./BasicSetting.vue?vue&type=template&id=5ebb2bfe&scoped=true"
import script from "./BasicSetting.vue?vue&type=script&lang=js"
export * from "./BasicSetting.vue?vue&type=script&lang=js"
import style0 from "./BasicSetting.vue?vue&type=style&index=0&id=5ebb2bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb2bfe",
  null
  
)

export default component.exports